import { host } from '../../config'
const state = {
	config: {
	  host,
  }
}

// getters
const getters = {
  config: state => state.config
}

// actions
const actions = {
}

export const mutations = {

}


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js